import { render, staticRenderFns } from "./AddPhoneNumbers.vue?vue&type=template&id=47eabf98&scoped=true&"
import script from "./AddPhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./AddPhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./AddPhoneNumbers.vue?vue&type=style&index=0&id=47eabf98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eabf98",
  null
  
)

export default component.exports